// DO NOT EDIT THIS FILE, EDIT THE WEBPACK COMMON CONFIG INSTEAD, WHICH WILL MODIFY THIS FILE
let _VERSION = '0.0.0'; // This value will be overwritten by webpack
let _DEBUG_INFO_ENABLED = true; // This value will be overwritten by webpack
_VERSION = "0.0.0";
_DEBUG_INFO_ENABLED = false;
export const VERSION = _VERSION;
export const DEBUG_INFO_ENABLED = _DEBUG_INFO_ENABLED;



// WEBPACK FOOTER //
// ./~/string-replace-webpack-plugin/loader.js?id=qnb9lk3w7b1nf3zv0vxdvaemi!./src/main/webapp/app/app.constants.ts